export default __webpack_public_path__ + "static/wordpress-65fee9f895f1e3439d4a3bd9ec32d248.png";